// extracted by mini-css-extract-plugin
export var actionButton = "_g7-0";
export var fileInput = "_g7-2";
export var paperclip = "_g7-1";